// extracted by mini-css-extract-plugin
export default {"nav":"AuthNavigation_nav__nO5o6","link":"AuthNavigation_link__FI7ZE","active":"AuthNavigation_active__S+6vX"};